export const accessTokenKey = "token";
export const baseUrl = process.env.REACT_APP_BASE_URL;
export const cqBaseUrl = process.env.REACT_APP_CQ_BASE_URL;
export const appBaseUrl = process.env.REACT_APP_CQ_BASE_URL + "/api/app";
export const rootBaseUrl = process.env.REACT_APP_CQ_BASE_URL + "/api";
export const appNotifyUrl =process.env.REACT_APP_NOTIFY_URL;